/**
 * @file PPD Album Custom Print cart item component.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'lodash.flowright';

import { PPD_CART_ITEM_TYPES } from '../../constants/ppd-purchase';
import { deselectAlbumCustomPrint as deselectAlbumCustomPrintAction } from '../../actions/ppd-purchase';
import {
  getAlbumCustomPrintName,
  getAlbumCustomPrintPrice,
} from '../../util/custom-prints';
import { AVATAR_SIZE_52 } from '../../constants/avatar-sizes';
import IdentityAvatarContainer from '../global/identity/IdentityAvatarContainer';
import Button from '../../components/global/Button';
import TrashIcon from '../../components/icons/TrashIcon';
import { formatPriceForDisplay } from '../../util/format-money';

const propTypes = {
  cartItem: PropTypes.shape({
    type: PropTypes.oneOf([PPD_CART_ITEM_TYPES.ALBUM_CUSTOM_PRINT]),
    selectedIdentity: PropTypes.shape({
      id: PropTypes.string,
    }),
    albumCustomPrint: PropTypes.shape({
      custom_print: PropTypes.shape({
        name: PropTypes.string,
      }),
    }),
  }),
  onDiscount: PropTypes.bool,
  deselectAlbumCustomPrint: PropTypes.func.isRequired,
};

const PurchasePpdAlbumCustomPrintCartItem = ({
  cartItem,
  deselectAlbumCustomPrint,
  onDiscount,
}) => {
  const { albumCustomPrint, selectedIdentity } = cartItem;
  const { identity } = selectedIdentity;

  return (
    <div className="ppd-cart-item py-2 px-1">
      <div className="d-flex">
        <div className="cart-item-image d-flex flex-column align-items-center justify-content-center">
          <IdentityAvatarContainer size={AVATAR_SIZE_52} identity={identity} />
          <span className="mt-1 text-dark">{identity.name}</span>
        </div>

        <div className="cart-item-desc">
          <p className="text-sm text-dark m-0">
            {getAlbumCustomPrintName(albumCustomPrint)} Purchase
          </p>
          <p className="text-xs text-faded m-0">For {identity.name}</p>

          <div className="d-flex align-items-center">
            <p className="text-sm text-bold text-dark mb-0 mr-2">
              $
              {formatPriceForDisplay(
                getAlbumCustomPrintPrice(albumCustomPrint, onDiscount),
              )}
            </p>
            <Button
              className="ml-auto"
              btnStyle="reset"
              onClick={() =>
                deselectAlbumCustomPrint(selectedIdentity, albumCustomPrint)
              }
            >
              <TrashIcon size={23} color="#f1524b" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

PurchasePpdAlbumCustomPrintCartItem.propTypes = propTypes;

const mapDispatchToProps = {
  deselectAlbumCustomPrint: deselectAlbumCustomPrintAction,
};

export default compose(connect(null, mapDispatchToProps))(
  PurchasePpdAlbumCustomPrintCartItem,
);
